import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupScrollBehavior()
  }

  setupScrollBehavior() {
    // Enable smooth scrolling on mouse wheel
    this.element.addEventListener('wheel', (e) => {
      // Only handle horizontal scrolling
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        return // Let default horizontal scroll happen
      }
      
      // Prevent vertical scrolling and convert to horizontal
      if (e.deltaY !== 0) {
        e.preventDefault()
        this.element.scrollLeft += e.deltaY
      }
    }, { passive: false })

    // Add smooth scrolling CSS
    this.element.style.scrollBehavior = 'smooth'
  }

  // Method to scroll to specific guide (could be useful for keyboard navigation)
  scrollToGuide(index) {
    const guides = this.element.querySelectorAll('[data-guide-index]')
    if (guides[index]) {
      guides[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      })
    }
  }

  // Handle touch/drag scrolling on mobile
  disconnect() {
    // Clean up any event listeners if needed
  }
} 